import { render, staticRenderFns } from "./SupervisorOrders.vue?vue&type=template&id=235c40b4"
import script from "./SupervisorOrders.vue?vue&type=script&lang=js"
export * from "./SupervisorOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports